import { render, staticRenderFns } from "./product-details-scheduled-content.vue?vue&type=template&id=4b757fe0&scoped=true&"
import script from "./product-details-scheduled-content.vue?vue&type=script&lang=js&"
export * from "./product-details-scheduled-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b757fe0",
  null
  
)

export default component.exports